import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/carApplications/history/list',
    method: 'post',
    data,
  })
}
export async function getDetail(params) {
  return request({
    url: '/carApplications/history/detail',
    method: 'get',
    params,
  })
}
// 撤销审核(车辆预约申请记录)
export async function revokeForHis(data) {
  return request({
    url: '/carApplications/revokeForHis',
    method: 'post',
    data,
  })
}
// 撤销审核(车辆预约信息管理)
export async function revokeForAllHis(data) {
  return request({
    url: '/carApplications/revokeForAllHis',
    method: 'post',
    data,
  })
}